/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { ProductLineItem, Quantity } from '@modules/billing-api/v1/types'

import { ProductType } from '../types'

export interface DeploymentInstanceWithAggregatedCosts extends TotalDeploymentCostsPerDimension {
  id: string
  name: string
}

export interface TotalDeploymentCostsPerDimension {
  capacity: number
  dataTransfer: number
  storage: number
  synthetics: number
  total_ecu: number
  inference: number
}

export interface TotalProjectCollapsedCosts {
  total_ecu: number
  type: ProjectSolution[] | ProjectSolution
}

export interface TotalCCMCollapsedCosts {
  total_ecu: number
}

export type ProjectSolution = 'security' | 'elasticsearch' | 'observability'

export enum IconType {
  TABLE = 'table',
  LINE_CHART = 'line_chart',
  BAR_CHART = 'bar_chart',
}

export interface Props {
  organizationId: string
  setInstanceName: (instanceName?: string) => void
}

export interface PLI extends Omit<ProductLineItem, 'quantities' | 'quantity'> {
  isTierRootPLI?: boolean
  isNonTierRootPLI?: boolean
  isTier?: boolean
  from?: string
  to?: string
  previewPrice?: number
  quantity?: Quantity
}

export type ProductViewInstanceType =
  | 'deployment'
  | 'elasticsearch'
  | 'observability'
  | 'security'
  | 'serverless_support'
  | 'serverless_addons'
  | 'cloud_connect'

export const mapProductToProductType: Record<ProductViewInstanceType, ProductType> = {
  deployment: ProductType.Deployments,
  cloud_connect: ProductType.CCM,
  elasticsearch: ProductType.Projects,
  observability: ProductType.Projects,
  security: ProductType.Projects,
  serverless_support: ProductType.Projects,
  serverless_addons: ProductType.Projects,
}
